import {Icon} from '~/components/icon'
import {getCheckboxIconName} from '~/components/checkbox/helpers'
import '../components/control/index.less'
import './index.less'

// This is a non-accessible, purely cosmetic checkbox "indicator".
// Commonly used inside a clickable container such as Select/Dropdown item.
export const CosmeticCheckbox = ({checked, disabled}) => {
	let state = 'unchecked'
	if (checked === 'indeterminate') state = 'indeterminate'
	else if (checked === true) state = 'checked'

	return (
		<div className="cosmetic-checkbox checkbox-control" data-state={state} data-disabled={disabled || undefined} aria-hidden="true">
			{state !== 'unchecked' && <Icon name={getCheckboxIconName(state)} />}
		</div>
	)
}
